import { AxiosResponse } from 'axios';
import axios from './axios-handler.service';
const BASE_URL = "/api/Email";

export enum FiltroEmail {
    Todos = 1,
    ComPlanoAtivo = 2,
    ComPlanoAtivoGratis = 3,
    ComPlanoAtivoLite = 4,
    ComPlanoAtivoEssencial = 5,
    ComPlanoAtivoEssencialConectada = 6,
    ComPlanoAtivoSuperConectada = 7,
    ComPlanoAtivoHiperConectada = 8,
    SemPlanoAtivo = 9
}

export interface EmailConfiguracao {
    nmRemetente: string;
    emailRemetente: string;
    nmResponderPara: string;
    emailResponderPara: string;
    assunto: string;
}

export interface EmailAgendamento {
    dtAgendamento: string;
    hrAgendamento: string;
    enviosHora?: number | null;
}

export interface EmailFiltro{
    filtro?: FiltroEmail | number;
    query?: string;
}

export interface NovoEmail extends EmailConfiguracao, EmailAgendamento, EmailFiltro {
    corpoEmail: string;
}

/**
 * Serviço de e-mail
 */
export class EmailService {
    /**
     * Retorna o número de consultores resultante da query
     * @param query Consulta a ser análisada
     */
    static obterQuantidadeConsultor(query: string): Promise<number>;
    /**
     * Retorna o número de consultores resultante de um filtro selecionado
     * @param filtro Filtro selecionado 
     */
    static obterQuantidadeConsultor(filtro: FiltroEmail | number): Promise<number>;
    static async obterQuantidadeConsultor(token: FiltroEmail | number | string): Promise<number> {
        let processo: Promise<AxiosResponse<number>>;

        //Se não for numérico
        if (Number.isNaN(+token)) {
            processo = axios.post(`${BASE_URL}/VerificarQuery`, { query: token });
        } else {
            processo = axios.get(`${BASE_URL}/ObterQuantidadeConsultores`, { params: { filtro: token } })
        }

        const response = await processo;
        return response.data;
    }

    static async agendar(email: NovoEmail): Promise<void>{
        await axios.post(`${BASE_URL}/Agendar`, email);
    }
}